export default {
    COTA: 1,
    COTA_EXAME: 2,
    PRAZO_VALIDADE: 3,
    LIMITE_ANUAL: 4,
}